"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rocketSymbol = void 0;
const NAME = 'rocket';
exports.rocketSymbol = {
    name: NAME,
    lockedAspectRatio: true,
    startWithFixedAspectRatio: true,
    hasStrokeSettings: false,
};
//# sourceMappingURL=RocketSymbol.js.map